import { BannerId } from '../typings/banners';
import { EditBannersSessionValue } from '../typings/bannersEditState';
import { GroupId } from '../typings/groups';

import { Session } from './Session/Session';
import { StorageKeyType } from './Storage/Storage';

export class BannersIdsForBannersEditHelpers {
    public static setCampAndBannerIds(login: string, bannersIds: Array<BannerId> = [], isNew: boolean = false): void {
        const currentSession = Session.getValueFromCurrentSession(login);

        Session.setValueToCurrentSession(login, {
            ...currentSession,
            [StorageKeyType.editBanners]: {
                bannersIds,
                campaignsIds: currentSession.campaignsIds || [],
                groupsIds: currentSession.groupsIds || [],
                isNew
            }
        });
    }

    public static setCampAndGroupIdsForCreation(
        login: string,
        campaignsIds: Array<string>,
        groupsIds: Array<GroupId>
    ): void {
        const currentSession = Session.getValueFromCurrentSession(login);

        Session.setValueToCurrentSession(login, {
            ...currentSession,
            campaignsIds,
            groupsIds,
            [StorageKeyType.editBanners]: {
                bannersIds: [],
                campaignsIds,
                groupsIds,
                isNew: true
            }
        });
    }

    public static getBannersEditSessionValue(login: string): EditBannersSessionValue {
        const { editBanners } = Session.getValueFromCurrentSession(login);
        if (!editBanners) {
            return {
                campaignsIds: [],
                groupsIds: [],
                bannersIds: [],
                isNew: false
            };
        }

        return editBanners;
    }
}
